module.exports = __webpack_public_path__ + "static/media/Messenger_Guide_Chin.eef67c34.docx";